import React, { useState } from "react";
import { Box, useMediaQuery, CircularProgress } from "@mui/material";
import theme from "../../theme";
import Image from "../../assets/Images/OperatingAgreement.svg";
import { BatchCardIcon } from "../../assets/Icon/headerCicon";
import { useDispatch } from "react-redux";
import { createCheckoutSession } from "../../stores/clients";
import { setToast } from "../../stores/toast/toastslice";

const OAStepOne = ({ pending }: { pending: boolean }) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const [btnLoading, setBtnLoading] = useState(false);

  const handleClick = async () => {
    setBtnLoading(true);
    const response = await dispatch<any>(createCheckoutSession()).unwrap();
    if (response?.code === 400) {
      dispatch<any>(
        setToast({
          message: response?.message,
          type: "error",
          title: "Error",
        })
      );
      return;
    }
    setBtnLoading(false);
    window.location.href = response.url;
  };
  const isLargeScreen = useMediaQuery("(max-width:1440px)");
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: isMobile ? 0 : 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "100vh",
          width: "100%",
          padding: isMobile ? 0 : 2,
          bgcolor: "white",
          marginTop: 1,
          paddingTop: isMobile ? 2 : 5,
          paddingBottom: 5,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <img
            src={Image}
            alt="Operating Agreement"
            style={{
              maxWidth: isLargeScreen ? "200px" : "256px",
              height: isLargeScreen ? "210px" : "268px",
            }}
          />
          <div
            style={{
              marginTop: isMobile ? "20px" : "28px",
              display: "grid",
              padding: isMobile ? "0 12px" : "0",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "20px" : isTablet ? "24px" : "28px",
                fontWeight: 700,
                textAlign: "center",
                margin: 0,
              }}
            >
              {/* Operating Agreement */}
              Operating Agreement Preparer
            </p>
            <p
              style={{
                fontSize: isMobile ? "14px" : isTablet ? "15px" : "16px",
                color: "#6C6F71",
                width: isMobile ? "100%" : isTablet ? "400px" : "550px",
                textAlign: "center",
                marginTop: isMobile ? 8 : 11,
                margin: "auto",
              }}
            >
              Custom Operating Agreement Generator — Just upload your company
              documents and passport, and voilà! Our tool handles the rest.
            </p>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                width: "250px",
                margin: "auto",
                borderRadius: "12px",
                backgroundColor: "#EAF1FA66",
                padding: "10px 20px",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {/* <span style={{ fontSize: "16px",textAlign: "left",width: "100%" , fontWeight: 400 }}>Price</span> */}
                <span
                  style={{
                    fontSize: "30px",
                    textAlign: "left",
                    width: "100%",
                    fontWeight: "bold",
                    color: "#2977CC",
                  }}
                >
                  $118
                </span>
              </div>
              <div
                style={{
                  border: "0.2px solid #A7C7EA",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  padding: "10px 20px",
                }}
              >
                <BatchCardIcon />
              </div>
            </Box>
            {!pending ? (
              <button
                style={{
                  margin: "auto",
                  paddingTop: isMobile ? "12px" : "16px",
                  paddingBottom: isMobile ? "12px" : "16px",
                  paddingLeft: isMobile ? "24px" : "30px",
                  paddingRight: isMobile ? "24px" : "30px",
                  borderRadius: "8px",
                  background: btnLoading
                    ? "#BDBDBD"
                    : "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  border: "none",
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: 600,
                  marginTop: isMobile ? "16px" : "22px",
                  cursor: "pointer",
                  minWidth: isMobile ? "140px" : "auto",
                  height: "52px",
                  opacity: btnLoading ? 0.7 : 1,
                }}
                onClick={btnLoading ? undefined : handleClick}
                disabled={btnLoading}
              >
                {btnLoading ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  </span>
                ) : (
                  "Place Order"
                )}
              </button>
            ) : (
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "#ed0c0cff",
                  backgroundColor: "#d7d2d290",
                  padding: "10px",
                  borderRadius: "7px",
                  marginTop: 20,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                Note: Previous payment is under progress. Please allow a few
                minutes for the transaction to complete.
                <CircularProgress size={20} />
              </div>
            )}
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default OAStepOne;
